import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './ClientModal.css';

function UserModal({ user, onClose, onSave }) {
  const [formData, setFormData] = useState({
    nom: '',
    email: '',
    password: '',
    role: 'agent',
    is_agent_cee: 0,
    cree_agents_cee: 0,
    is_agent_pacpv: 0,
    cree_agents_pacpv: 0,
    taux_commission: '0',
    commission_fixe: '0',
    commission_superviseur: '0',
    commission_base: '0',
    chef_equipe_id: '',
    reduction_max_ia: 0
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [chefsEquipe, setChefsEquipe] = useState([]);
  const API_URL = process.env.REACT_APP_API_URL || '';

  useEffect(() => {
    if (user) {
      setFormData({
        nom: user.nom || '',
        email: user.email || '',
        password: '',
        role: user.role || 'agent',
        is_agent_cee: user.is_agent_cee ? 1 : 0,
        cree_agents_cee: user.cree_agents_cee ? 1 : 0,
        is_agent_pacpv: user.is_agent_pacpv ? 1 : 0,
        cree_agents_pacpv: user.cree_agents_pacpv ? 1 : 0,
        taux_commission: user.taux_commission || '0',
        commission_fixe: user.commission_fixe || '0',
        commission_superviseur: user.commission_superviseur || '0',
        commission_base: user.commission_base || '0',
        chef_equipe_id: user.chef_equipe_id || '',
        reduction_max_ia: user.reduction_max_ia || 0
      });
    }
    // Charger la liste des chefs d'équipe
    fetchChefsEquipe();
  }, [user]);

  const fetchChefsEquipe = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_URL}/api/chefs-equipe`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setChefsEquipe(response.data);
    } catch (error) {
      console.error('Erreur chargement chefs équipe:', error);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError('');
  };

  // Pseudo-rôles par pôle (exclusifs). Agent → is_agent_* ; Chef → cree_agents_* (détermine ses agents ET sa vue).
  const handleRoleChange = (e) => {
    const val = e.target.value;
    const base = { ...formData, is_agent_cee: 0, cree_agents_cee: 0, is_agent_pacpv: 0, cree_agents_pacpv: 0 };
    if (val === 'agent_cee') {
      setFormData({ ...base, role: 'agent', is_agent_cee: 1 });
    } else if (val === 'agent_pacpv') {
      setFormData({ ...base, role: 'agent', is_agent_pacpv: 1 });
    } else if (val === 'chef_equipe_cee') {
      setFormData({ ...base, role: 'chef_equipe', cree_agents_cee: 1 });
    } else if (val === 'chef_equipe_pacpv') {
      setFormData({ ...base, role: 'chef_equipe', cree_agents_pacpv: 1 });
    } else {
      setFormData({ ...base, role: val });
    }
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    // Validation
    if (!user && !formData.password) {
      setError('Le mot de passe est requis pour un nouvel utilisateur');
      setLoading(false);
      return;
    }

    try {
      const dataToSend = { ...formData };
      // Si c'est une modification et pas de nouveau mot de passe, ne pas l'envoyer
      if (user && !formData.password) {
        delete dataToSend.password;
      }
      await onSave(dataToSend);
    } catch (err) {
      setError(err.response?.data?.error || 'Erreur lors de la sauvegarde');
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h2>{user ? 'Modifier l\'utilisateur' : 'Nouvel utilisateur'}</h2>
          <button className="btn-close" onClick={onClose}>&times;</button>
        </div>
        <form onSubmit={handleSubmit} className="modal-form">
          <div className="form-group">
            <label htmlFor="nom">Nom complet *</label>
            <input
              type="text"
              id="nom"
              name="nom"
              value={formData.nom}
              onChange={handleChange}
              placeholder="Jean Dupont"
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="email">Email *</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="jean.dupont@crm.com"
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">
              Mot de passe {user ? '(laisser vide pour ne pas modifier)' : '*'}
            </label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="••••••••"
              required={!user}
            />
          </div>
          <div className="form-group">
            <label htmlFor="role">Rôle *</label>
            <select
              id="role"
              name="role"
              value={
                formData.role === 'agent' && formData.is_agent_cee ? 'agent_cee'
                : formData.role === 'agent' && formData.is_agent_pacpv ? 'agent_pacpv'
                : formData.role === 'chef_equipe' && formData.cree_agents_cee ? 'chef_equipe_cee'
                : formData.role === 'chef_equipe' && formData.cree_agents_pacpv ? 'chef_equipe_pacpv'
                : formData.role
              }
              onChange={handleRoleChange}
              required
            >
              <optgroup label="E-SHOPS">
                <option value="agent">Agent Téléphonique (eshops)</option>
                <option value="chef_equipe">Chef d'équipe (eshops)</option>
                <option value="commercial">Directeur Commercial</option>
              </optgroup>
              <optgroup label="CEE">
                <option value="agent_cee">Agent Téléphonique CEE</option>
                <option value="chef_equipe_cee">Chef d'équipe CEE</option>
              </optgroup>
              <optgroup label="PAC / PV (financement)">
                <option value="agent_pacpv">Agent Téléphonique PAC/PV</option>
                <option value="chef_equipe_pacpv">Chef d'équipe PAC/PV</option>
              </optgroup>
              <optgroup label="Validation">
                <option value="valideur">Valideur de comptes</option>
              </optgroup>
              <optgroup label="Ressources humaines">
                <option value="rh">RH — Candidat Assu</option>
              </optgroup>
              <optgroup label="E-SHOPS CONNECT">
                <option value="suivi_connect">Suivi E-SHOPS CONNECT (cet onglet uniquement)</option>
              </optgroup>
              <optgroup label="ia.e-application.fr">
                <option value="commercial_ia">Commercial ia.e-application.fr (cet onglet uniquement)</option>
              </optgroup>
              <optgroup label="Administration">
                <option value="sous_admin">Sous-Admin</option>
                <option value="superviseur">Superviseur</option>
                <option value="superviseur_agent">Superviseur + Agent</option>
                <option value="admin">Administrateur</option>
              </optgroup>
            </select>
            <small style={{color: '#666', fontSize: '12px'}}>
              Le pôle (E-Shops / CEE / PAC-PV) est exclusif. Un chef d'équipe crée des agents de son pôle et voit les onglets de son pôle.
              Le valideur ne voit que Compte Assu et Candidat Assu, en lecture seule, avec le seul pouvoir de valider les comptes.
              Le RH ne voit que Candidat Assu, qu'il gère entièrement, sans pouvoir supprimer une fiche ni un dossier.
              Le rôle Suivi E-SHOPS CONNECT ne voit que l'onglet Suivi E-SHOPS CONNECT, et peut tout y gérer.
              Le Commercial ia.e-application.fr ne voit que l'onglet ia.e-application.fr (ses clients).
            </small>
          </div>
          {formData.role === 'commercial_ia' && (
            <div className="form-group">
              <label htmlFor="reduction_max_ia">Réduction max que ce commercial peut accorder (%)</label>
              <input
                type="number"
                id="reduction_max_ia"
                name="reduction_max_ia"
                min="0"
                max="100"
                value={formData.reduction_max_ia}
                onChange={handleChange}
              />
              <small style={{color: '#666', fontSize: '12px'}}>
                Un code de réduction unique lui sera généré automatiquement côté ia.e-application.fr. Les clients qui l'utilisent lui sont rattachés.
              </small>
            </div>
          )}
          {(formData.role === 'chef_equipe' || formData.role === 'sous_admin') && (
            <div className="form-group">
              <label htmlFor="commission_base">Commission de base (€)</label>
              <input
                type="number"
                id="commission_base"
                name="commission_base"
                value={formData.commission_base}
                onChange={handleChange}
                placeholder="150"
                step="0.01"
                min="0"
              />
              <small style={{color: '#666', fontSize: '12px'}}>
                {formData.role === 'sous_admin'
                  ? 'Commission par client payé pour le sous-admin et ses agents directs'
                  : 'Montant total que le chef d\'équipe pourra distribuer à ses agents'
                }
              </small>
            </div>
          )}
          {formData.role === 'agent' && chefsEquipe.length > 0 && (
            <div className="form-group">
              <label htmlFor="chef_equipe_id">Chef d'équipe (optionnel)</label>
              <select
                id="chef_equipe_id"
                name="chef_equipe_id"
                value={formData.chef_equipe_id}
                onChange={handleChange}
              >
                <option value="">Aucun chef d'équipe</option>
                {chefsEquipe.map(chef => (
                  <option key={chef.id} value={chef.id}>
                    {chef.nom} (Base: {chef.commission_base}€)
                  </option>
                ))}
              </select>
              <small style={{color: '#666', fontSize: '12px'}}>
                Assigner cet agent à un chef d'équipe
              </small>
            </div>
          )}
          {(formData.role === 'agent' || formData.role === 'commercial' || formData.role === 'superviseur_agent') && (
            <>
              <div className="form-group">
                <label htmlFor="taux_commission">Taux de commission (%)</label>
                <input
                  type="number"
                  id="taux_commission"
                  name="taux_commission"
                  value={formData.taux_commission}
                  onChange={handleChange}
                  placeholder="30"
                  step="0.01"
                  min="0"
                  max="100"
                />
                <small style={{color: '#666', fontSize: '12px'}}>Commission en pourcentage sur chaque paiement</small>
              </div>
              <div className="form-group">
                <label htmlFor="commission_fixe">Commission fixe (€)</label>
                <input
                  type="number"
                  id="commission_fixe"
                  name="commission_fixe"
                  value={formData.commission_fixe}
                  onChange={handleChange}
                  placeholder="150"
                  step="0.01"
                  min="0"
                />
                <small style={{color: '#666', fontSize: '12px'}}>Commission fixe unique par nouveau client (1er paiement)</small>
              </div>
            </>
          )}
          {(formData.role === 'superviseur' || formData.role === 'superviseur_agent') && (
            <div className="form-group">
              <label htmlFor="commission_superviseur">Commission superviseur par client payé (€)</label>
              <input
                type="number"
                id="commission_superviseur"
                name="commission_superviseur"
                value={formData.commission_superviseur}
                onChange={handleChange}
                placeholder="60"
                step="0.01"
                min="0"
              />
              <small style={{color: '#666', fontSize: '12px'}}>Commission versée quand un client de ses agents supervisés est totalement payé</small>
            </div>
          )}
          {error && <div className="error-message">{error}</div>}
          <div className="modal-actions">
            <button type="button" onClick={onClose} className="btn-cancel">
              Annuler
            </button>
            <button type="submit" className="btn-save" disabled={loading}>
              {loading ? 'Enregistrement...' : 'Enregistrer'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default UserModal;
